module.exports = {
	"en": {
		"BIOS/MAINBOARD": "BIOS / Mainboard",
		"COMPANY": "Company",
		"DESCRIPTION": "Description",
		"DEVICE": "Device",
		"DEVICELOCATOR": "Device locator",
		"DEVICEMANUFACTURER": "Device manufacturer",
		"DEVICEPARTNUMBER": "Device partnumber",
		"DEVICESIZE": "Device size",
		"DISK": "Disk",
		"DISPLAY": "Display",
		"HOTFIX_ID": "Hotfix ID",
		"INSTALLDATE": "Install date",
		"LOCALINFO": "Locale info",
		"ListInventoryWidget": "Inventory",
		"MAINBOARD": "Mainboard",
		"MEMORYDEVICE": "Memory device",
		"OS Servicepack": "OS Service pack",
		"OS_HOTFIX": "OS hotfix",
		"PLANNED": "Planned",
		"PRODUKT": "Product",
		"PROGRAMS": "Software",
		"SWVERSION": "Software version",
		"SYSTEM": "System",
		"UNPLANNED": "Unplanned"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locale/en.json
// module id = 749
// module chunks = 0 1